import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch"

const deletePaymentPlanElement = (
    backend: string,
    token: string,
    id: number
) => {
    return fetch(
        `${getApiUrl(backend)}payment_plan_elements/${id}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        }
    );
};

export default deletePaymentPlanElement;
